import { render, staticRenderFns } from "./TermsViewer.vue?vue&type=template&id=31be58da"
import script from "./TermsViewer.vue?vue&type=script&lang=js"
export * from "./TermsViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports